import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';
import clsx from 'clsx';
import React, { Component } from 'react';
import Sockette from 'sockette';

import { toastWhenWindowClose } from '../../../SweetAlertUtil/util';

import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import { convertToLangKey, getNavigationalWindowObject, getSessionRemainngTime } from '../../../AppUtil/AppUtil';
import { logPageView } from '../../../AppUtil/analytics';
import LoanCalculator from '../../../LoanCalculator';
import ApiService from '../../../Service/ApiService';
import Session from '../../../Service/Session';
import TenantService from '../../../Service/TenantService';
import Auth from '../../Auth';
import DwollaPlaid from '../../Common/DwollaPlaid';
import Loans from '../../Common/Loans';
import Notification from '../../Common/Notification';
import ViewSummary from '../../Common/ViewSummary/index';
import LoanList from '../../LoanList';
import Profile from '../../Profile';
import Workflow from '../../Workflows';
import LanguageSelector from '../Base/Nav/LanguageSelector';
import Landing from '../Landing';
import Nav from './Nav';
import SideNav from './SideNav';

import AmortizationTable from '../../../Admin/Customer/Loans/AmortizationTable';
import InvitationService from '../../../Service/InvitationService';
import ServiceChargeService from '../../../Service/ServiceChargeService';
import LinkExpired from '../../Common/linkExpired';
import './material.light_blue-blue.min.css';
import './material.min.css';
import './styles.css';
import BuxService from '../../../Service/BuxService';
import { hot } from 'react-hot-loader';

const AppConfig = window.AppConfig;
const API_URLS = AppConfig.API_URLS;

const colors = ['bg-pink', 'bg-purple', 'bg-green'];

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			userType: 'USER',
			expiryReason: '',
			_idOfWorkflowSelected: 1,
			_openAuth: 'SIGN_IN',
			_isSideNavOpen: false,
			_currentUser: null,
			_openedScreen: 'HOME',
			_supportedStates: [],
			_error: '',
			_hashedSupportedStates: null,
			_supportedFrequency: [],
			_supportedRelations: [],
			_supportedWorkflows: [],
			openNotification: false,
			anchorEl: null,
			_notificationData: [],
			_isNotificationLoad: true,
			_notificationCount: 0,
			_serviceCharge: [],
			_listSize: 4,
			_activeWorkflows: null,

			_user: {
				emailId: '',
				first_name: '',
				last_name: '',
				address: '',
				phone: '',
				countryCode: '',
				state: ''
			},
			_ws: null,
			_dwollaCallBacks: () => {}, // NOSONAR
			_authCallBacks: () => {} // NOSONAR
		};
		window.openScreen = this.openScreen;
		window.openDwollaPlaid = this.openDwollaPlaid;
		window.openAuthWhenLoanExists = this.openAuthWhenLoanExists;
	}

	getNotification = async () => {
		try {
			await ApiService.GetData(`${API_URLS.NOTIFICATION_MARK_AS_READ}`);
			this.setState({
				_notificationCount: 0
			});
		} catch (err) {
			console.log(err);
		}
	};

	openAuth = screen => {
		this.setState({
			_openAuth: screen
		});
	};

	openSideNav = () => {
		this.setState({
			_isSideNavOpen: true
		});
	};

	closeSideNav = () => {
		this.setState({
			_isSideNavOpen: false
		});
	};

	fetchState = async () => {
		try {
			const hashState = {};
			const id = window.location.host;
			let url = id.split('.');

			// uncommit below line to make tis api work in local
			// 		url = id.split(':');
			//= ===================

			// url = ['lta-ph-stage'];
			url = ['app'];

			const states = await ApiService.GetData(`${API_URLS.STATE}/${url[0]}`, 'default', false);

			states &&
				states.sort((a, b) => {
					if (a.name > b.name) {
						return 1;
					} else {
						if (b.name > a.name) {
							return -1;
						} else {
							return 0;
						}
					}
				});
			const supportedState = states.map(state => {
				hashState[state.id] = state;
				return {
					label: state.name,
					value: state.id
				};
			});
			this.setState({
				_supportedStates: supportedState,
				_hashedSupportedStates: hashState
			});
			Session.store('STATES', hashState);
			Session.store('SUPPORTED_STATES', supportedState);
		} catch (error) {
			console.log(error);
		}
	};

	fetchServicecharge = async () => {
		try {
			const result = await ServiceChargeService.getList();

			const servicecharge = result.service_charge.map(service_charge => ({
				min: service_charge.min,
				max: service_charge.max,
				price: service_charge.price
			}));

			this.setState({ _serviceCharge: servicecharge });
			Session.store('SERVICE_CHARGE', servicecharge);
		} catch (e) {
			console.log(e);
		}
	};

	fetchFrequency = async () => {
		try {
			const response = await ApiService.GetData(API_URLS.FREQUENCY, 'default', false);

			const frequencies = response.map(frequency => ({
				label: convertToLangKey(frequency.name),
				value: frequency.name
			}));

			this.setState({ _supportedFrequency: frequencies });
			Session.store('frequencies', frequencies);
		} catch (error) {
			console.log(error);
		}
	};

	fetchRelations = async () => {
		try {
			const relation = await ApiService.GetData(API_URLS.RELATIONSHIPS, 'default', false);
			const relations = relation.map(relationObject => {
				return {
					label: convertToLangKey(relationObject.name),
					value: relationObject.name
				};
			});
			this.setState({ _supportedRelations: relations });
		} catch (error) {}
	};

	setMetaData = () => {
		this.fetchState();
		this.fetchFrequency();
		this.fetchRelations();
		this.fetchServicecharge();
		this.setError();
		getSessionRemainngTime(); // will remove after testing
	};

	setCurrentUser = user => {
		this.setState({
			_currentUser: user
		});
	};

	setAuthUser = user => {
		const fullName = user.name.split(' ');
		let firstName = '';
		let lastName = '';
		if (fullName.length > 1) {
			firstName = fullName[0];
			lastName = fullName[1];
		} else {
			firstName = fullName[0];
		}
		const updatedUser = {
			emailId: user.emailId,
			first_name: firstName,
			last_name: lastName,
			address: user.address,
			phone: user.phone,
			countryCode: user.countryCode,
			state: user.state
		};
		this.setState({
			_user: updatedUser
		});
	};

	handleNotificationOpen = event => {
		this.setState(
			{
				openNotification: true,
				anchorEl: event.currentTarget,
				_listSize: 4
			},
			() => {
				this.getNotification();
			}
		);
	};

	handleNotificationClose = () => {
		this.setState({
			anchorEl: null
		});
	};

	setListSize = () => {
		this.setState({
			_listSize: this.state._notificationData.length
		});
	};

	setError = () => {
		const error = localStorage.getItem('error');

		if (error) {
			this.setState({ _error: error });
		}
	};

	setScreenOpen = screen => {
		if (
			this.props.props.match.path === '/loan/:id' ||
			this.props.props.match.path === '/amortization-table/:id' ||
			this.props.props.match.path === '/modify-loan/:id' ||
			// this.props.props.match.path === '/loan-calculator' ||
			this.props.props.match.path === '/signin' ||
			this.props.props.match.path === '/signup'
		) {
			this.props.props.history.push('/');
		}
		this.setState(
			{
				_openedScreen: null
			},
			() => {
				this.setState({
					_openedScreen: screen
				});
			}
		);
	};

	openScreen = screen => {
		if (getNavigationalWindowObject()) {
			const store = getNavigationalWindowObject();
			toastWhenWindowClose(store, this.setScreenOpen, screen);
		} else {
			this.setScreenOpen(screen);
			// this.openAuth('SIGN_IN');
		}
	};

	openDwollaPlaid = async callBack => {
		await this.setState({ _dwollaCallBacks: callBack });
		this.openScreen('DWOLLA_PLAID');
	};

	setInitialScreen = async () => {
		// NOSONAR

		const currentUser = Session.get('CURRENT_USER_INFO');
		const params = new URLSearchParams(window.location.search);
		if (this.isRouteAvalable()) {
			let expiryFlag = true;
			if (params.get('u')) {
				const reqBody = {
					link: params.get('u'),
					loan_id: this.props.props.match.params.id
				};
				const resp = await InvitationService.linkValidation(reqBody);
				if (resp.data) {
					this.setState({
						expiryReason: resp.data.msg
					});
					expiryFlag = resp.data.valid;
				}
				this.setState({
					userType: 'GUARANTOR'
				});
			}
			if (expiryFlag === true) {
				if (currentUser) {
					this.setState({ _openedScreen: 'HOME' }, () => {
						if (this.props.props.match.path === '/profile') {
							this.setState({
								_openedScreen: 'PROFILE'
							});
						} else if (this.props.props.match.path === '/admin/loans/:id') {
							this.setState({
								_openedScreen: 'ADMIN_LOANS'
							});
						} else if (this.props.props.match.path === '/amortization-table/:id') {
							this.setState({
								_openedScreen: 'AMORTIZATION_TABLE'
							});
						} else {
							this.setState({
								_openedScreen: 'LOAN_LIST'
							});
						}
					});
				} else {
					this.setState({
						_openedScreen: 'AUTH'
					});
					if (params.get('name') && params.get('invitationCode')) {
						this.openAuth('SIGN_UP');
					} else {
						this.openAuth('SIGN_IN');
					}
				}
			} else {
				// redirect to new page
				this.setState({
					_openedScreen: 'EXPIRED_PAGE'
				});
			}
		} else if (this.props.props.match.path === '/signup') {
			if (!currentUser) {
				this.setState({
					_openedScreen: 'AUTH'
				});
				this.openAuth('SIGN_UP');
			} else {
				this.props.props.history.push('/');
			}
		} else if (this.props.props.match.path === '/signin') {
			if (!currentUser) {
				this.setState({
					_openedScreen: 'AUTH'
				});
				this.openAuth('SIGN_IN');
			} else {
				this.props.props.history.push('/');
			}
		} else if (this.props.props.match.path === '/reset-password' && params.get('phone')) {
			this.setState({
				_openedScreen: 'AUTH'
			});
			this.openAuth('ResetPasswordForm');
		} else {
			this.setState({
				_openedScreen: 'HOME'
			});
		}
	};

	openScreenWhenBackFromViewSummary = _id => {
		// TO-DO handle back button from view summary
	};

	setTypeOfWorkFlowSelected = id => {
		this.setState({ _idOfWorkflowSelected: id });
	};

	setScreen = () => {
		const isOpenDwollaPlaid = new URLSearchParams(window.location.search).get('action');
		switch (this.state._openedScreen) {
			case 'OPEN_WORKFLOW':
				logPageView('/app/setuploan'); // NOSONAR
				return (
					<Workflow
						currentUser={this.state._currentUser}
						idOfWorkflowSelected={this.state._idOfWorkflowSelected}
						openAuth={this.openAuth}
						openScreen={this.openScreen}
						setAuthUser={this.setAuthUser}
						supportedFrequency={this.state._supportedFrequency}
						supportedRelationships={this.state._supportedRelations}
						supportedStates={this.state._supportedStates}
					/>
				);

			case 'DWOLLA_PLAID':
				return (
					<DwollaPlaid
						currentUser={this.state._currentUser}
						onBack={this.state._dwollaCallBacks}
						onClose={this.state._dwollaCallBacks}
						openScreen={this.openScreen}
						setCurrentUser={this.setCurrentUser}
						supportedStates={this.state._supportedStates}
					/>
				);
			case 'AUTH':
				logPageView('/app/auth'); // NOSONAR
				return (
					<Auth
						onCloseWhenLoanExists={this.state._authCallBacks}
						openAuth={this.state._openAuth}
						openScreen={this.openScreen}
						props={this.props.props}
						currentUser={this.state._currentUser}
						setCurrentUser={this.setCurrentUser}
						setInitialScreen={this.setInitialScreen}
						supportedStates={this.state._supportedStates}
						user={this.state._user}
					/>
				);
			case 'VIEW_SUMMARY':
				logPageView('/app/view-summary'); // NOSONAR
				return (
					<ViewSummary
						currentUser={this.state._currentUser}
						idOfWorkflowSelected={this.state._idOfWorkflowSelected}
						onBack={this.openScreenWhenBackFromViewSummary}
						openScreen={this.openScreen}
						setCurrentUser={this.setCurrentUser}
						supportedStates={this.state._supportedStates}
					/>
				);
			case 'LOAN_CALCULATOR':
				logPageView('/app/loan-calculator'); // NOSONAR
				return <LoanCalculator openScreen={this.openScreen} />;
			case 'LOAN_LIST':
				logPageView('/app/loan-list'); // NOSONAR
				return (
					<LoanList
						error={this.state._error}
						currentUser={this.state._currentUser}
						hashedSupportedStates={this.state._hashedSupportedStates}
						openScreen={this.openScreen}
						props={this.props.props}
						setCurrentUser={this.setCurrentUser}
						supportedFrequency={this.state._supportedFrequency}
						supportedRelationships={this.state._supportedRelations}
						supportedStates={this.state._supportedStates}
						userType={this.state.userType}
					/>
				);
			case 'PROFILE':
				logPageView('/app/profile'); // NOSONAR
				return (
					<Profile
						error={this.state._error}
						currentUser={this.state._currentUser}
						isOpenDwollaPlaid={isOpenDwollaPlaid}
						openScreen={this.openScreen}
						props={this.props.props}
						setCurrentUser={this.setCurrentUser}
						supportedStates={this.state._supportedStates}
					/>
				);
			case 'ADMIN_LOANS':
				return <Loans currentUser={this.state._currentUser} props={this.props.props} />;
			case 'AMORTIZATION_TABLE':
				return <AmortizationTable currentUser={this.state._currentUser} props={this.props.props} />;
			case 'EXPIRED_PAGE':
				return <LinkExpired reason={this.state.expiryReason} />;
			case 'HOME':
			default:
				return (
					<Landing
						error={this.state._error}
						activeWorkflows={this.state._activeWorkflows}
						currentUser={this.state._currentUser}
						openAuth={this.openAuth}
						openedScreen={this.state._openedScreen}
						openScreen={this.openScreen}
						setTypeOfWorkflowSelected={this.setTypeOfWorkFlowSelected}
					/>
				);
		}
	};

	setAuth = () => {
		const currentUser = Session.get('CURRENT_USER_INFO');
		if (currentUser) {
			this.setState({
				_currentUser: currentUser
			});
		}
	};

	isRouteAvalable = () => {
		return (
			this.props.props.match.path === '/loan/:id' ||
			this.props.props.match.path === '/amortization-table/:id' ||
			this.props.props.match.path === '/modify-loan/:id' ||
			this.props.props.match.path === '/profile'
			// this.props.props.history.location.pathname !== '/'
		);
	};

	openDwollaPlaid = async callBack => {
		await this.setState({ _dwollaCallBacks: callBack });
		this.openScreen('DWOLLA_PLAID');
	};

	openAuthWhenLoanExists = async (screen, callBack) => {
		await this.setState({ _authCallBacks: callBack });

		let user = JSON.parse(localStorage.getItem('USER'));

		delete user.state;

		localStorage.setItem('USER', JSON.stringify(user));

		this.setAuthUser(user);
		this.openAuth(screen);
		this.setState({ _openedScreen: 'AUTH' });
	};

	activeWorkflows = () => {
		const activeWorkflow = this.state._supportedWorkflows.filter(workflow => {
			workflow.background = colors[workflow.loan_workflow_id - 1];
			return workflow.is_active === true;
		});
		const activeWorkflows = {
			workflows: activeWorkflow,
			length: activeWorkflow.length
		};
		this.setState({
			_activeWorkflows: activeWorkflows
		});
	};

	setTenantMetaData = async () => {
		// const tenantName = window.location.hostname.split(".")[0]; // Subdomain

		const tenantName = 'app';
		// const tenantName = 'lta-ph-stage';

		const tenant = await TenantService.getByShortName(tenantName);
		Session.store('TENANT', tenant);
		const workflows = tenant.bpmn_deployments;
		workflows.sort((a, b) => {
			if (a.loan_workflow_id > b.loan_workflow_id) {
				return 1;
			} else {
				if (b.loan_workflow_id > a.loan_workflow_id) {
					return -1;
				} else {
					return 0;
				}
			}
		});
		this.setState({ _supportedWorkflows: workflows });
		this.activeWorkflows();
	};

	componentDidMount() {
		this.setTenantMetaData();
		this.setAuth();
		this.setMetaData();
		this.setInitialScreen();
	}

	setNotificationCount = async () => {
		try {
			const response = await ApiService.GetData(`${API_URLS.NOTIFICATION}`);
			const notification = response.notifications.sort((a, b) => {
				if (a.id < b.id) {
					return 1;
				} else {
					if (b.id < a.id) {
						return -1;
					} else {
						return 0;
					}
				}
			});
			this.setState({
				_notificationCount: response.notification_count,
				_notificationData: notification,
				_isNotificationLoad: false
			});
		} catch (error) {
			console.log(error);
			this.setState({
				_isNotificationLoad: false
			});
		}
	};

	setupWebSocketForNotification = () => {
		const connectionUrl = `${AppConfig.WEBSOCKET_ENDPOINT}?token=${this.state._currentUser.username}`;
		const ws = new Sockette(connectionUrl, {
			timeout: 5e3,
			maxAttempts: 10,
			onopen: e => console.log('Connected!', e),
			onmessage: e => {
				console.log('Received:', e);
				this.setNotificationCount();
			},
			onreconnect: e => console.log('Reconnecting...', e),
			onmaximum: e => console.log('Stop Attempting!', e),
			onclose: e => console.log('Closed!', e),
			onerror: e => console.log('Error:', e)
		});
		this.setState({
			_ws: ws
		});
	};

	componentDidUpdate(_prevProps, prevState) {
		if (this.state._currentUser !== null && prevState._currentUser === null) {
			this.setNotificationCount();
			if (!this.state._ws) {
				this.setupWebSocketForNotification();
			}
		}
	}

	render() {
		return (
			<div
				className="mdl-layout mdl-js-layout mdl-layout--fixed-header basic-background"
				onBlur={this.closeSideNav}>
				{/* component/home/base/index.js */}
				{/* WaveVector */}
				{/* <div alt="decoration" className="wave-img img-responsive no-print">
					<WaveVector/>
				</div> */}
				<img alt="decoration" className="wave-img img-responsive no-print" src="/images/white_wave.png" />
				<div
					className="android-header mdl-layout__header mdl-layout__header--waterfall unset-z-index"
					style={{ paddingBlock: '20px' }}>
					<div className="mdl-layout__header-row basic-background">
						<span className="android-title mdl-layout-title">
							{/* <img
						alt="Logo"
						className="android-logo-image no-print"
						src="/images/Lendami.png"
					/> */}
							<img className="android-logo-image no-print" src="/images/LendAmi-Philippines.svg" />
							<img alt="Logo" className="android-logo-black only-print" src="/images/LendamiBlack.png" />
						</span>
						{this.state.openNotification ? (
							<div>
								<Notification
									anchorEl={this.state.anchorEl}
									currentUser={this.state._currentUser}
									handleNotificationClose={this.handleNotificationClose}
									isNotificationLoad={this.state._isNotificationLoad}
									listSize={this.state._listSize}
									notificationData={this.state._notificationData}
									refreshNotification={this.setNotificationCount}
									setInitialScreen={this.setInitialScreen}
									setListSize={this.setListSize}
								/>
							</div>
						) : null}
						<div className="android-header-spacer mdl-layout-spacer" />
						<Nav
							currentUser={this.state._currentUser}
							handleNotificationOpen={this.handleNotificationOpen}
							notificationCount={this.state._notificationCount}
							openScreen={this.openScreen}
							setCurrentUser={this.setCurrentUser}
						/>
						<span
							className="android-mobile-title mdl-layout-title"
							style={{ justifyContent: 'space-between', paddingBlock: '20px' }}>
							{/* <img
						alt="Logo"
						className="android-logo-image"
						src="/images/Lendami.png"
					/> */}
							<img
								className="android-logo-image"
								src="/images/LendAmi-Philippines.svg"
								style={{ marginLeft: '35px', transform: 'translateX(32px)' }}
							/>
							<div
								style={{
									display: 'flex'
								}}>
								{this.state._currentUser ? (
									<div className="notif-badge-container">
										<IconButton aria-describedby="simple-popover" style={{ color: 'white' }}>
											<Badge
												badgeContent={(() => {
													if (this.state._notificationCount > 0) {
														return this.state._notificationCount;
													} else {
														return null;
													}
												})()}
												color="secondary"
												onClick={this.handleNotificationOpen}>
												<NotificationsIcon
													className="no-print"
													fontSize="large"
													onClick={this.handleNotificationOpen}
												/>
											</Badge>
										</IconButton>
									</div>
								) : null}
								<div className="language-selector">
									<LanguageSelector
										currentUser={this.state._currentUser}
										setCurrentUser={this.setCurrentUser}
									/>
								</div>
							</div>
						</span>
					</div>
				</div>
				<IconButton
					aria-label="_isSideNavOpen drawer"
					className={clsx(this.props.classMenu, this.state._isSideNavOpen && this.props.classHide)}
					color="inherit"
					edge="start"
					id="makeStyles-menuButton-5"
					onClick={this.openSideNav}>
					<MenuIcon className="no-print" />
				</IconButton>
				<SideNav
					closeSideNav={this.closeSideNav}
					currentUser={this.state._currentUser}
					isSideNavOpen={this.state._isSideNavOpen}
					openScreen={this.openScreen}
				/>
				<CssBaseline />
				<span className="uwu" />
				<Container className="main-body" maxWidth="lg">
					<Typography component="div">{this.setScreen()}</Typography>
				</Container>
			</div>
		);
	}
}

export default hot(module)(index);
